<video class="video-show" autoplay loop
       playsinline preload="metadata" poster="../../../assets/common/sprites/bg-download.jpg" crossorigin="anonymous"
       *ngIf="help">
    <source [src]="videoLink + src" type="video/mp4">
</video>



